import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    timeFormats: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.REMINDER_TIME_ZONE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.REMINDER_TIME_ZONE_SUCCESS: {
      const timeFormats = {};
      const result =
        action.response.data &&
        action.response.data.map((item) => {
          timeFormats[item.key] = item.shortCode;
          return {
            value: item.key,
            text: item.displayValue,
            shortCode: item.shortCode,
          };
        });
      return {
        ...state,
        data: result || [],
        timeFormats: timeFormats,
        isProgress: false,
      };
    }
    case homeConstants.REMINDER_TIME_ZONE_FAILURE:
      return {
        data: [],
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
